import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function NavMenu({ selectedMenu, onNavigationClick, basePath, navigationItems, onHamburgerClick }) {
    const params = useParams();
    const navigate = useNavigate();
    const projectId = params.projectId;
    const siteId = params.siteId;

    function handleNavigationClick(event) {
        var name = event.currentTarget.getAttribute("name");
        onNavigationClick(name);
        navigate(`${basePath}/${projectId??siteId}/${name}`);
    }

    let navItems = navigationItems && navigationItems.map(navItem => {
        let selectedClassName = navItem.path === selectedMenu ? "selected" : "";
        return (<li key={navItem.path} name={navItem.path} className={selectedClassName} onClick={handleNavigationClick}>
            <i className={navItem.iconClass} />
            <span className="navMenuItemDesc">{navItem.name}</span>
        </li>);
    });

    var hamburgerItem = onHamburgerClick && (<li className="hamburger" onClick={onHamburgerClick}>
        <i className="dhicon-menu-hamburger" />
    </li>);

    let navList = (<ul>{hamburgerItem}{navItems}</ul>);

    return (<div className="navigation-menu">{navList}</div>);
}